
export const INIT_CHART_DATA = [
  { col_0: '月份', col_1: '杭州', col_2: '温州', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '1月', col_1: '320', col_2: '120' },
  { col_0: '2月', col_1: '132', col_2: '282' },
  { col_0: '3月', col_1: '210', col_2: '111' },
  { col_0: '4月', col_1: '334', col_2: '234' },
  { col_0: '5月', col_1: '190', col_2: '220' },
  { col_0: '6月', col_1: '130', col_2: '340' },
  { col_0: '7月', col_1: '220', col_2: '310' },

]

export const TABLE_HEADER = { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' }

export const TABLE_ROW = { col_0: '', col_1: '', col_2: '', col_3: '', col_4: '', col_5: '', col_6: '', col_7: '' }

export const INIT_OBJECT_DATA = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '1月', col_1: '320' },
  { col_0: '2月', col_1: '132' },
  { col_0: '3月', col_1: '210' },
  { col_0: '4月', col_1: '334' },
  { col_0: '5月', col_1: '190' },
  { col_0: '6月', col_1: '130' },
  { col_0: '7月', col_1: '220' },

]
export const INIT_PIE_DATA = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '环比', col_7: '同比' },
  { col_0: '1月', col_1: '320' },
  { col_0: '2月', col_1: '132' },
  { col_0: '3月', col_1: '210' },
  { col_0: '4月', col_1: '334' },
  { col_0: '5月', col_1: '190' },
  { col_0: '6月', col_1: '130' },
  { col_0: '7月', col_1: '220' },
]
export const INIT_RANK_DATA = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '比率设置' },
  { col_0: '1月', col_1: '320' },
  { col_0: '2月', col_1: '132' },
  { col_0: '3月', col_1: '210' },
  { col_0: '4月', col_1: '334' },
  { col_0: '5月', col_1: '190' },
  { col_0: '6月', col_1: '130' },
  { col_0: '7月', col_1: '220' },
]

export const INIT_NUMBER_DATA = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '1200' },
]

export const INIT_MAP_DATA = [
  { col_0: '区县', col_1: '零售额(万)', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '温州市', col_1: '320' },
  { col_0: '宁波市', col_1: '132' },
  { col_0: '衢州市', col_1: '210' },
  { col_0: '杭州市', col_1: '334' },
  { col_0: '台州市', col_1: '190' },
  { col_0: '嘉兴市', col_1: '130' },
  { col_0: '金华市', col_1: '220' },
]

export const INIT_HEATMAP_DATA = [
  { col_0: '地区', col_1: '数值', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '温州市', col_1: '320' },
  { col_0: '宁波市', col_1: '132' },
  { col_0: '衢州市', col_1: '210' },
  { col_0: '杭州市', col_1: '334' },
  { col_0: '台州市', col_1: '190' },
  { col_0: '嘉兴市', col_1: '130' },
  { col_0: '金华市', col_1: '220' },
]
export const componentInitDataMap = new Map([
  ['line', INIT_CHART_DATA],
  ['areaLine', INIT_CHART_DATA],
  ['verticalBar', INIT_CHART_DATA],
  ['horizonBar', INIT_CHART_DATA],
  ['rank', INIT_RANK_DATA],
  ['barPolar', INIT_OBJECT_DATA],
  ['pie', INIT_PIE_DATA],
  ['pieCircular', INIT_PIE_DATA],
  ['mapChart', INIT_MAP_DATA],
  ['heatMapChart', INIT_HEATMAP_DATA],
  ['number', INIT_NUMBER_DATA],
  ['independentNumber', INIT_NUMBER_DATA],
  ['gaugeNumber', INIT_NUMBER_DATA],
  ['scrollTable', INIT_CHART_DATA],
  ['timeClock', []],
  ['richText', ''],
  ['filterBlock', {}],
])
// 现有组件列表及组件默认配置
export const COMPONENT_LIST = [

  {
    categoryName: '图形',
    components: [

      {
        addSn: 0,
        chartComponentType: 'LineChart',
        chartComponent: 'line',
        boxTitle: '折线图',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 200, // 默认高度
        chartTitle: '折线图', // 组件标题
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            smooth: false, // 平滑过度
            isLabel: true, // 是否展示标签
            carousel: false, // 轮播 tooltips
            carouselDelay: 3,
            isLinkMap: false,
            linkMap: undefined,
            doubleAxis: false, // 双y轴设置
            isLegend: false,
            legendSize: 12, // 图例字体大小

          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_CHART_DATA,
          initDataFlag: 1,
          //  数据来源指标设置
          initData: INIT_CHART_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/line.png',
      },
      {
        addSn: 0,
        chartComponentType: 'LineChart',
        chartComponent: 'areaLine',
        boxTitle: '面积图',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 200, // 默认高度
        chartTitle: '面积图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            smooth: false, // 平滑过度
            isLabel: true, // 是否展示标签
            carousel: false, // 轮播 tooltips
            carouselDelay: 3,
            isLegend: false,
            legendSize: 12, // 图例字体大小
            doubleAxis: false, // 双 y 轴
            areaGradientFade: false, // 面积填充自上而下过渡到黑色半透明

          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_CHART_DATA,
          initDataFlag: 1,
          initData: INIT_CHART_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/areaLine.png',

      },
      //  纵向 柱状图
      {
        addSn: 0,
        chartComponentType: 'BarChart',
        chartComponent: 'verticalBar',
        boxTitle: '柱状图 (纵向)',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 200, // 默认高度
        chartTitle: '柱状图 (纵向)',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: true, // 是否展示标签
            carousel: false, // 轮播 tooltips
            carouselDelay: 3,
            borderWidth: 10, // 柱形图宽度
            borderRadius: 10, // 柱形图圆角
            isLegend: false,
            legendSize: 12, // 图例字体大小

          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_CHART_DATA,
          initDataFlag: 1,
          initData: INIT_CHART_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/verticalBar.png',

      },
      //  横向 柱状图
      {
        addSn: 0,
        chartComponentType: 'BarChart',
        chartComponent: 'horizonBar',
        boxTitle: '柱状图 (横向)',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 350, // 默认高度
        chartTitle: '柱状图 (横向)',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: true, // 是否展示标签
            carousel: false, // 轮播 tooltips
            carouselDelay: 3,
            borderWidth: 10, // 柱形图宽度
            borderRadius: 10, // 柱形图圆角

          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_CHART_DATA,
          initDataFlag: 1,
          initData: INIT_CHART_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/horizonBar.png',

      },
      // 榜单图
      {
        addSn: 0,
        chartComponentType: 'Rank',
        chartComponent: 'rank',
        boxTitle: '榜单图',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 330, // 默认高度
        chartTitle: '榜单图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          chartStyle: {
            fontSize: 14,
            unit: '',
            max: 350,
            setRate: false,
            rateType: '', // 设置 同比环比 显示， ，同比: yearRate,  环比: quarterRate
            carousel: true,
            carouselDelay: 3,
            rateColor: '',
            setRankNumber: 5, // 设置榜单个数
            borderWidth: 10, // 柱条宽度（与横向柱状图一致）
            borderRadius: 10, // 柱条圆角（右侧圆角，与横向柱状图一致）
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_RANK_DATA,
          initDataFlag: 1,
          initData: INIT_RANK_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/rank.png',
      },
      //  极坐标 柱状图
      {
        addSn: 0,
        chartComponentType: 'BarChart',
        chartComponent: 'barPolar',
        boxTitle: '极坐标',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 400, // 默认宽度
        chartHeight: 200, // 默认高度
        chartTitle: '极坐标',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: false,
            max: 300, // 极坐标最大值
            internalRadius: 30, // 内径大小
            externalRadius: 70, // 外径大小
            carousel: false, // 轮播 tooltips
            carouselDelay: 3,
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_OBJECT_DATA,
          initDataFlag: 1,
          initData: INIT_OBJECT_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/polar.png',

      },
      {
        addSn: 0,
        chartComponentType: 'PieChart',
        chartComponent: 'pie',
        boxTitle: '饼图',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 400,
        chartHeight: 200,
        chartTitle: '饼图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: true,
            radius: 70, // 半径大小
            sliceBorderRadius: 0, // 扇区倒角(px)
            sliceBlackFill: 0, // 扇区之间黑色描边宽度(px)
            carousel: false,
            carouselDelay: 3,
            isLegend: false, // 是否展示图例
            legendSize: 12, // 图例字体大小
            legendPosition: 'top', // 图例位置: 上方: top, 右侧: right
            labelContent: 'percent', // 标签展示方式:  number: 数字, percent: 百分比
            setRate: false, // 比率设置， 环比同比
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_PIE_DATA,
          initDataFlag: 1,
          initData: INIT_PIE_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/pie.png',

      },
      {
        addSn: 0,
        chartComponentType: 'PieChart',
        chartComponent: 'pieCircular',
        boxTitle: '环形图',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 400,
        chartHeight: 200,
        chartTitle: '环形图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: true, // 是否展示标签
            internalRadius: 45, // 内径大小
            externalRadius: 70, // 外径大小
            sliceBorderRadius: 0, // 扇区倒角(px)
            sliceBlackFill: 0, // 扇区之间黑色描边宽度(px)
            carousel: false, // 是否显示轮播
            carouselDelay: 3,
            isLegend: false, // 是否展示图例
            legendSize: 12, // 图例字体大小
            legendPosition: 'top', // 图例位置: 上方: top, 右侧: right
            labelContent: 'percent', // 标签展示方式:  number: 数字, percent: 百分比
            setRate: false, // 比率设置， 环比同比
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: INIT_PIE_DATA,
          initDataFlag: 1,
          initData: INIT_PIE_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/circular.png',

      },
      {
        addSn: 0,
        chartComponentType: 'MapChart',
        chartComponent: 'mapChart',
        boxTitle: '地图',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 600, // 默认宽度
        chartHeight: 400, // 默认高度
        chartTitle: '地图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            color: '#ccc', // 组件文字：地图区域标签、图例（visualMap）等
            map: ['100000', '330000'],
            isLabel: true, // 是否展示标签
            carousel: true, // 轮播 tooltips
            carouselDelay: 3,
            /** 开启轮播时，tooltip 自动切换对应的区域高亮填充色 */
            carouselHighlightColor: '#ff3333',
            /** 指标航线：线宽、飞线尾迹(0~1)、动效符号与尺寸、像素速度、落点 pin 大小 */
            mapRouteLineWidth: 1.2,
            mapRouteTrailLength: 0.35,
            mapRouteLineColor: '#5ED5FE',
            mapRouteEffectSymbolSizeW: 4,
            mapRouteEffectSymbolSizeH: 5,
            mapRouteConstantSpeed: 48,
            mapRouteScatterSymbolSize: 9,
            zoom: 1, // 缩放比例
            heatByValue: false, // 按数值热力着色（越深数值越大）
            /** 与数值热力配合：使用 ECharts visualMap 分段着色（关闭则按 min-max 渐变） */
            hasVisualMap: false,
            visualMapOption: {
              type: 'piecewise',
              pieces: [],
              text: [],
            },
          },
          dataSource: '',
        },
        jumpPanelId: '',
        chartViewData: {
          chartData: INIT_MAP_DATA,
          initDataFlag: 1,
          initData: INIT_MAP_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/map.png',

      },
      {
        addSn: 0,
        chartComponentType: 'HeatMapChart',
        chartComponent: 'heatMapChart',
        boxTitle: '热力图',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 600, // 默认宽度
        chartHeight: 400, // 默认高度
        chartTitle: '热力图',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          chartStyle: {
            fontSize: 12,
            isLabel: false, // 是否展示标签
            carousel: true, // 轮播 tooltips
            carouselDelay: 3,
            zoom: 4, // 缩放比例
            mapStyle: 'blue', // 地图样式
            highlightCount: 0, // 高亮数量
            lng: 115, // 地图中心经度
            lat: 33, // 地图中心纬度
          },
          dataSource: '',
        },
        jumpPanelId: '',
        chartViewData: {
          chartData: INIT_HEATMAP_DATA,
          initDataFlag: 1,
          initData: INIT_HEATMAP_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,
        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/heatamp.png',

      },
    ],
  },
  {
    categoryName: '数字',
    components: [
      {
        addSn: 0,
        chartComponentType: 'Number',
        boxTitle: '纯数字',
        chartComponent: 'number',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 220, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '纯数字',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'center',
            fontSize: 16,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
            color: '#0276fa', // 边框颜色
          },
          chartStyle: {
            fontSize: 36,
            color: '#fff', // 数字字体颜色
            hasSymbol: false,
            symbolColor: '#fff',
            symbolText: '',
            symbolFontSize: 16,
            symbolPosition: 'left',
          },
          dataSource: '',
        },
        clickJump: '', // 点击后跳转大屏
        initData: true, // 是否为初始化数据
        chartViewData: {
          chartData: INIT_NUMBER_DATA,
          initDataFlag: 1,
          initData: INIT_NUMBER_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        // rawData: ,
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/number1.1.png',
      },
      {
        addSn: 0,
        chartComponentType: 'IndependentNumber',
        boxTitle: '独立数字',
        chartComponent: 'independentNumber',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 320, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '独立数字',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'center',
            fontSize: 16,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
            color: '#0276fa', // 边框颜色
            numberBorderType: 1,
          },
          chartStyle: {
            fontSize: 38,
            color: '#fff', // 数字字体颜色
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        initData: true, // 是否为初始化数据
        // rawData: INIT_NUMBER_DATA,
        chartViewData: {
          chartData: INIT_NUMBER_DATA,
          initDataFlag: 1,
          initData: INIT_NUMBER_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },

        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/number2.png',
      },
      {
        addSn: 0,
        chartComponentType: 'Gauge',
        boxTitle: '仪表盘',
        chartComponent: 'gaugeNumber',
        active: false, // 是否选中
        draggable: true, // 是否可拖动

        chartX: 0,
        chartY: 0,
        chartWidth: 200, // 默认宽度
        chartHeight: 200, // 默认高度
        chartTitle: '仪表盘',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'center',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
            color: '#0276fa', // 边框颜色
          },
          chartStyle: {
            fontSize: 24,
            axisLabel: true,
            color: '#ccc', // 数字字体颜色
            max: 2000,
            arrowLength: 56,
            unit: '',
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        initData: true, // 是否为初始化数据
        // rawData: INIT_NUMBER_DATA,
        chartViewData: {
          chartData: INIT_NUMBER_DATA,
          initDataFlag: 1,
          initData: INIT_NUMBER_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/number3.png',
      },
    ],
  },
  {
    categoryName: '表格',
    components: [
      {
        addSn: 0,
        chartComponentType: 'ScrollTable',
        chartComponent: 'scrollTable',
        boxTitle: '滚动列表',
        active: false, // 是否选中
        draggable: true, // 是否可拖动

        chartX: 0,
        chartY: 0,
        chartWidth: 580, // 默认宽度
        chartHeight: 250, // 默认高度
        chartTitle: '滚动列表',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'left',
            fontSize: 14,
          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
            color: '#0276fa', // 边框颜色
            isLinkMap: false,
            linkMap: undefined,
          },
          chartStyle: {
            fontSize: 16,
            color: '#333',
            stripe: true,
            isScroll: true,
            step: 0.4, // 滚动速度
            direction: 1, // 滚动方向
            hoverStop: true, // 鼠标悬停
            isLinkMap: false,
            linkMap: undefined,

          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        initData: true, // 是否为初始化数据
        chartViewData: {
          chartData: INIT_CHART_DATA,
          initDataFlag: 1,
          initData: INIT_CHART_DATA,
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/table1.png',
      },
    ],
  },
  {
    categoryName: '素材',
    components: [
      {
        addSn: 0,
        chartComponentType: 'TextBlock',
        chartComponent: 'text',
        boxTitle: '标题',
        active: false, // 是否选中
        draggable: true, // 是否可拖动

        chartX: 0,
        chartY: 0,
        chartWidth: 200, // 默认宽度
        chartHeight: 56, // 默认高度
        chartTitle: '标题',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: 'center',
            fontSize: 28,
            fontFamily: '',
          },
          chartStyle: {

          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: [],
          initDataFlag: 1,
          initData: [],
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/text.png',
      },
      // 当前时间（年月日时分秒）
      {
        addSn: 0,
        chartComponentType: 'TimeClock',
        chartComponent: 'timeClock',
        boxTitle: '时间',
        active: false,
        draggable: true,
        chartX: 0,
        chartY: 0,
        chartWidth: 320,
        chartHeight: 72,
        chartTitle: '',
        chartSet: {
          chartStyle: {
            fontSize: 28,
            color: '#fff',
            textAlign: 'center',
            fontFamily: '',
          },
          timeDisplay: {
            year: true,
            month: true,
            day: true,
            hour: true,
            minute: true,
            second: true,
          },
          borderStyle: {
            border: 'none',
            borderTemplate: '',
          },
          dataSource: '',
        },
        jumpPanelId: '',
        chartViewData: {
          chartData: [],
          initDataFlag: 1,
          initData: [],
          selectedIndicatorList: [],
          showIndicator: false,
        },
        sort: undefined,
        templateImg: 'https://oss.qlinyun.com/test/picture/DZYifTBAPNBJZKxGsF5XYyp33FHHkk8n.png',
      },
      // 富文本编辑
      {
        addSn: 0,
        chartComponentType: 'RichTextBlock',
        chartComponent: 'richText',
        boxTitle: '文本',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 260, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '文本',
        chartSet: {
          titleStyle: {
            color: '#fff',
            align: '',
            fontSize: 5,
            fontFamily: '',
            fontStyle: {
              bold: '',
              italic: '',
              underline: '',
              strikeThrough: '',
              color: '',
              fontSize: '',
            }, // 字体样式 粗体: bold, 斜体: italic, 下划线: underline, 删除线: StrikeThrough
          },
          chartStyle: {

          },
          borderStyle: {
            border: 'none', // none || template
            borderTemplate: '',
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: '',
          initDataFlag: 1,
          initData: '',
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/richText.png',
      },
      // 边框组件
      {
        addSn: 0,
        chartComponentType: 'BorderBlock',
        chartComponent: 'borderBlock',
        boxTitle: '边框',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 260, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '',
        chartSet: {
          titleStyle: {
          },
          chartStyle: {
            borderRadius: 0,
            borderColor: 'rgba(255,255,255,.5)',
            borderWidth: 0,
            backgroundColor: 'rgba(0,0,0,0)',
            hasCorner: true,
            cornerColor: '#fff',
            borderType: 1,
          },
          borderStyle: {
          },
          dataSource: '',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: '',
          initDataFlag: 1,
          initData: '',
          selectedIndicatorList: [],
          showIndicator: false,
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/borderBlock.png',
      },
      // 筛选组件
      {
        addSn: 0,
        chartComponentType: 'FilterBlock',
        chartComponent: 'filterBlock',
        boxTitle: '筛选',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 350, // 默认宽度
        chartHeight: 40, // 默认高度
        chartTitle: '',
        chartSet: {
          titleStyle: {
          },
          chartStyle: {
            borderColor: 'rgba(255,255,255,.5)',
            backgroundColor: 'rgba(0,0,0,0)',
            fontSize: 14,
            color: '#fff',
            filterType: 'date',
            hideInView: false, // 查看大屏时隐藏控件（编辑页仍显示）
          },
          borderStyle: {
          },
          dataSource: 'customize',
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: '',
          initData: {},
          initDataFlag: 1,
          selectedIndicatorList: [],
          showIndicator: false,
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/filterBlock.png',
      },
      // 署名组件
      {
        addSn: 0,
        chartComponentType: 'SignName',
        chartComponent: 'signName',
        boxTitle: '署名',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 240, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '',
        chartSet: {
          titleStyle: {
          },
          chartStyle: {
            background: 'transparent',
            textColor: '#fff',
            signName: '',
            signUrl: '',
          },
          borderStyle: {
            borderRadius: 0,
            borderColor: '#fff',
            borderWidth: 1,
            hasCorner: true,
            cornerColor: '#fff',
            borderType: 1,
          },
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: '',
          initDataFlag: 1,
        },
        sort: undefined,

        templateImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/borderBlock.png',
      },
      // 署名组件
      {
        addSn: 0,
        chartComponentType: 'imageBlock',
        chartComponent: 'imageBlock',
        boxTitle: '图片',
        active: false, // 是否选中
        draggable: true, // 是否可拖动
        chartX: 0,
        chartY: 0,
        chartWidth: 240, // 默认宽度
        chartHeight: 120, // 默认高度
        chartTitle: '',
        chartSet: {
          titleStyle: {
          },
          chartStyle: {
            background: 'transparent',
          },
          borderStyle: {
          },
        },
        jumpPanelId: '', // 点击后跳转大屏
        chartViewData: {
          chartData: [
            { col_0: '图片地址', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
            { col_0: 'https://oss.qlinyun.com/test/picture/J4mwzX64kskpTrSxDPfGA6BCzctBpyMc.jpg' },
          ],
          initDataFlag: 1,
          initData: [
            { col_0: '图片地址', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
            { col_0: 'https://oss.qlinyun.com/test/picture/J4mwzX64kskpTrSxDPfGA6BCzctBpyMc.jpg' },
          ],
          selectedIndicatorList: [], // 数据指标
          showIndicator: false, // 指标说明
        },
        sort: undefined,

        templateImg: 'https://oss.qlinyun.com/test/picture/J4mwzX64kskpTrSxDPfGA6BCzctBpyMc.jpg',
      },
    ],
  },

]
